import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";

export const fetchCioSegments = async (user) => {
    try {
        const { data } = await axios.get(`${API_BASE_URL}/segments/customer-io`, buildHeaders(user))
        return data
    } catch (error) {
        console.error(error)
        throw error
    }
}
